import React from 'react';

const LogoCSS = () => {
  const logoStyle = {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Arial, sans-serif',
    textDecoration: 'none',
    color: 'white'
  };

  const logoBoxStyle = {
    background: 'linear-gradient(135deg, #6c5ce7 0%, #fd79a8 100%)',
    borderRadius: '6px',
    width: '36px',
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '10px',
    fontWeight: 'bold',
    position: 'relative'
  };

  const textContainerStyle = {
    display: 'flex',
    flexDirection: 'column'
  };

  const mainTextStyle = {
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '1',
    color: 'white'
  };

  const subTextStyle = {
    fontSize: '10px',
    color: 'rgba(255, 255, 255, 0.8)',
    lineHeight: '1'
  };

  const circleStyle1 = {
    position: 'absolute',
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: '#00b894',
    top: '-3px',
    right: '-3px'
  };

  const circleStyle2 = {
    position: 'absolute',
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: '#fdcb6e',
    bottom: '-3px',
    right: '-3px'
  };

  return (
    <div style={logoStyle}>
      <div style={logoBoxStyle}>
        <span>GH</span>
        <div style={circleStyle1}></div>
        <div style={circleStyle2}></div>
      </div>
      <div style={textContainerStyle}>
        <span style={mainTextStyle}>职工之家</span>
        <span style={subTextStyle}>NEDL EMPLOYEE HOME</span>
      </div>
    </div>
  );
};

export default LogoCSS;
